import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFSuggestedCalculation = {
  correctionDelivered: number;
  carbBolusDelivered: number;
  correctionProgrammed: number;
  carbBolusProgrammed: number;
  correctionSuggested: number;
  carbBolusSuggested: number;
  correctionIOB: number;
  mealIOB: number;
  correctionFactorUsed: number;
  currentGlycemia: number;
  targetGlycemia: number;
  glycemiaCorrectionThreshold: number;
  carbs: number;
  icRatioUsed: number;
};

export const IBF_SUGGESTED_CALCULATION = {
  value: 0x0040,
  name: "IBF_SUGGESTED_CALCULATION",
  size: 10,
  parse: (record, info): IBFSuggestedCalculation => {
    const correctionDelivered = record.nextUInt32LE() / 100.0;
    const carbBolusDelivered = record.nextUInt32LE() / 100.0;
    const correctionProgrammed = record.nextUInt32LE() / 100.0;
    const carbBolusProgrammed = record.nextUInt32LE() / 100.0;
    const correctionSuggested = record.nextInt32LE() / 100.0;
    const carbBolusSuggested = record.nextUInt32LE() / 100.0;
    const correctionIOB = record.nextUInt32LE() / 100.0;
    const mealIOB = record.nextUInt32LE() / 100.0;
    let correctionFactorUsed = record.nextUInt16LE();
    let currentGlycemia = record.nextUInt16LE();
    const targetGlycemia = record.nextUInt16LE();
    const glycemiaCorrectionThreshold = record.nextUInt16LE();
    let carbs = record.nextUInt16LE();
    let icRatioUsed = record.nextUInt16LE();
    if (currentGlycemia === 65535) {
      currentGlycemia = 0;
    }
    if (carbs === 65535) {
      carbs = 0;
    }
    if (info.isOmnipodDash) {
      correctionFactorUsed /= 100.0;
      icRatioUsed /= 10.0;
      carbs /= 10.0;
    }
    return {
      correctionDelivered,
      carbBolusDelivered,
      correctionProgrammed,
      carbBolusProgrammed,
      correctionSuggested,
      carbBolusSuggested,
      correctionIOB,
      mealIOB,
      correctionFactorUsed,
      currentGlycemia,
      targetGlycemia,
      glycemiaCorrectionThreshold,
      carbs,
      icRatioUsed,
    };
  },
} satisfies IBFHistoryRecordDefinition<IBFSuggestedCalculation>;
